import * as IntegrationTest from "./IntegrationTest/index.js";
/** CoStar.Api.Underwriting.ViewModels.AnalyticsImageType */
export var AnalyticsImageType;
(function (AnalyticsImageType) {
    AnalyticsImageType[AnalyticsImageType["None"] = 0] = "None";
    AnalyticsImageType[AnalyticsImageType["Chart"] = 1] = "Chart";
    AnalyticsImageType[AnalyticsImageType["Map"] = 2] = "Map";
})(AnalyticsImageType || (AnalyticsImageType = {}));
/** CoStar.Api.Underwriting.ViewModels.MatchType */
export var MatchType;
(function (MatchType) {
    MatchType[MatchType["Unknown"] = 0] = "Unknown";
    MatchType[MatchType["Property"] = 1] = "Property";
    MatchType[MatchType["PostalCode"] = 2] = "PostalCode";
    MatchType[MatchType["City"] = 3] = "City";
    MatchType[MatchType["BuildingName"] = 4] = "BuildingName";
    MatchType[MatchType["Submarket"] = 5] = "Submarket";
    MatchType[MatchType["Street"] = 6] = "Street";
    MatchType[MatchType["ResearchMarket"] = 7] = "ResearchMarket";
    MatchType[MatchType["Contact"] = 8] = "Contact";
    MatchType[MatchType["Company"] = 9] = "Company";
    MatchType[MatchType["County"] = 10] = "County";
    MatchType[MatchType["Subdivision"] = 11] = "Subdivision";
    MatchType[MatchType["GeocodeResult"] = 12] = "GeocodeResult";
    MatchType[MatchType["BuildingPark"] = 13] = "BuildingPark";
    MatchType[MatchType["ShoppingCenter"] = 14] = "ShoppingCenter";
    MatchType[MatchType["Country"] = 15] = "Country";
    MatchType[MatchType["PostalCodeGroup"] = 16] = "PostalCodeGroup";
    MatchType[MatchType["Region"] = 17] = "Region";
    MatchType[MatchType["StoreType"] = 18] = "StoreType";
    MatchType[MatchType["CSA"] = 19] = "CSA";
    MatchType[MatchType["PropertyResidential"] = 20] = "PropertyResidential";
    MatchType[MatchType["Cluster"] = 21] = "Cluster";
    MatchType[MatchType["Airport"] = 22] = "Airport";
    MatchType[MatchType["HotelName"] = 23] = "HotelName";
    MatchType[MatchType["TransitStation"] = 24] = "TransitStation";
    MatchType[MatchType["Military"] = 25] = "Military";
    MatchType[MatchType["University"] = 26] = "University";
    MatchType[MatchType["StoreBrand"] = 27] = "StoreBrand";
    MatchType[MatchType["GoogleResults"] = 28] = "GoogleResults";
    MatchType[MatchType["PropertyManagers"] = 29] = "PropertyManagers";
    MatchType[MatchType["SearchEngineOptimization"] = 30] = "SearchEngineOptimization";
    MatchType[MatchType["StreetIntersections"] = 31] = "StreetIntersections";
    MatchType[MatchType["Metro"] = 32] = "Metro";
    MatchType[MatchType["ParkAndRecreation"] = 33] = "ParkAndRecreation";
    MatchType[MatchType["ActiveCompany"] = 34] = "ActiveCompany";
    MatchType[MatchType["TenantLocation"] = 35] = "TenantLocation";
    MatchType[MatchType["TrueOwner"] = 36] = "TrueOwner";
    MatchType[MatchType["SchoolWithAttendanceZone"] = 37] = "SchoolWithAttendanceZone";
    MatchType[MatchType["SchoolWithNoAttendanceZone"] = 38] = "SchoolWithNoAttendanceZone";
    MatchType[MatchType["SchoolDistrict"] = 39] = "SchoolDistrict";
    MatchType[MatchType["CityAggregate"] = 40] = "CityAggregate";
    MatchType[MatchType["MultifamilyProperty"] = 41] = "MultifamilyProperty";
    MatchType[MatchType["PropertyGroup"] = 42] = "PropertyGroup";
    MatchType[MatchType["DMA"] = 43] = "DMA";
    MatchType[MatchType["CoStarMarket"] = 132] = "CoStarMarket";
    MatchType[MatchType["TrueCity"] = 133] = "TrueCity";
})(MatchType || (MatchType = {}));
export { IntegrationTest };
